import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { NSKeys } from '@app/i18n';
import Api from '@app/services/api';
import { getResponseStatus } from '@app/services/apiErrors';
import { useApiErrorMessage } from '@app/services/hooks/useApiErrorMessage';

import { COUNTERPARTY_ORDERS_PATH, counterpartyOrderQueryKey } from '@pages/CounterpartyOrders';

export const useCounterpartyOrderRedirectQuery = (orderUid: string) => {
  const client = useQueryClient();
  const navigate = useNavigate();
  const documentsT = useTranslation(NSKeys.warehouseDocuments);
  const getErrorMessage = useApiErrorMessage();

  return useMutation({
    mutationFn: () => Api.orders.getCounterpartyOrder(orderUid),
    onSuccess: (order) => {
      client.setQueryData(counterpartyOrderQueryKey(orderUid), order);
      navigate(`${COUNTERPARTY_ORDERS_PATH}/${orderUid}`);
    },
    onError: (err) => {
      if (getResponseStatus(err) === 404) {
        message.warning(documentsT.t('order.unavailable'));
      } else {
        message.error(getErrorMessage(err));
      }
    },
  });
};
